/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import analytics from "analytics/analytics";
import template from "../templates/modules/overlays/wishlist_confirmation_prompt";
import Overlay from "../utils/overlay";
import globalEvents from "../utils/global-events";
import { gettext } from "modules/django-i18n";
import globals from "modules/globals";

let overlay;
const WISHLIST_CARD = ".wishlist-card";

export default baustein.register("wishlist-delete", {
    defaultOptions: {
        deleteProductId: null,
    },
    init() {
        this.onClick = this.onClick.bind(this);
        this.openOverlay = this.openOverlay.bind(this);
        this.closeOverlay = this.closeOverlay.bind(this);
        this.deleteCard = this.deleteCard.bind(this);
        this.removeEventBindings = this.removeEventBindings.bind(this);
    },
    setupEvents(add) {
        add("click", this.onClick);
    },
    onClick() {
        analytics.event("click", "delete saved item");
        this.openOverlay();
    },
    openOverlay() {
        overlay = new Overlay({
            cssClasses: ["size-m", "white"],
            content: template({
                product_id: this.options.deleteProductId,
                title: gettext("saved_items.remove_items_wishlist"),
                // "Are you sure you want to remove this item from your wishlist?"
                no: gettext("your_lysts.delete_lyst.cancel_btn_text"),
                yes: gettext("your_lysts.delete_lyst.confirm_btn_text")
            }),
            onOverlayClose: () => {
                this.removeEventBindings();
                analytics.event("dismissed saved item unsubscribe prompt", "clicked");
            }
        });
        globalEvents.on("confirmation-prompt-closed", this.closeOverlay);
        globalEvents.on("confirmation-prompt-yes", this.deleteCard);
    },
    deleteCard() {
        globalEvents.trigger("member-feature-decrease-count");
        this.el.parentElement.remove();
        this.removeEventBindings();
        overlay.close();
        const itemCount = document.querySelectorAll(WISHLIST_CARD).length;
        if (itemCount === 0) {
            globals.window.location.reload();
            return;
        }
    },
    closeOverlay() {
        this.removeEventBindings();
        overlay.close();
    },
    removeEventBindings() {
        globalEvents.off("confirmation-prompt-closed", this.closeOverlay);
        globalEvents.off("confirmation-prompt-yes", this.deleteCard);
    }
});

